/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------------------
 * Pop-up de saida: desktop calibrado + mobile revisado em 10/09/2026.
 * Touch/coarse/tela estreita prevalecem sobre hover/fine. Back arma em 20s;
 * fallback visivel em 40s se Back nao chegar (inclusive barra Draft).
 * Aba oculta nao conta como exibicao: abre ao retornar, se ja armado.
 * Uma exibicao, descanso de 7 dias; nao reempilha historico ao abrir.
 *
 * Reclamacao do Thiago: o pop-up dos 10% aparecia so de navegar entre colecoes.
 * Duas causas no Warehouse:
 *   1. "Show once to visitors" estava desligado, entao ele reabria a cada pagina;
 *   2. o tema arma o gatilho em `document.body` mouseleave, sem olhar POR ONDE o
 *      cursor saiu nem ha quanto tempo o visitante esta na pagina. Ir para o menu,
 *      para a barra de rolagem ou para outra aba ja contava como "saindo".
 *
 * Nao da para remover o listener nativo (esta numa closure do theme.js), mas ele
 * so abre o pop-up quando `localStorage.themeExitPopup` esta ausente. Entao o
 * controle aqui e feito por essa chave:
 *   - fica BLOQUEADA nos primeiros segundos da visita;
 *   - depois disso, so e liberada enquanto o cursor esta na faixa superior da
 *     tela, que e o caminho real de quem vai fechar a aba ou usar a barra do
 *     navegador;
 *   - depois de exibido, volta a aparecer so apos o periodo de descanso.
 *
 * MOBILE (06/09): "sai sem aparecer o pop-up" nao e essa calibragem — e o proprio
 * Warehouse. `ExitPopup._attachListeners()` (theme.js) comeca com
 * `if (!Responsive.matchesBreakpoint("supports-hover")) return;` e sai ANTES de
 * registrar o `mouseleave`. Em touch nao ha hover, entao o tema nunca liga o
 * gatilho nativo — nao existe popup de saida em celular por design deste tema
 * (o proprio schema documenta: "Only visible on desktop"). O close button e o
 * click-outside tambem ficam sem listener pelo mesmo motivo.
 * Como nao ha "mouse saindo da tela" em touch, o proxy de exit-intent mobile
 * usado aqui e o botao/gesto de VOLTAR do navegador: depois do mesmo delay de
 * armar, empilha um estado de historico; o primeiro "voltar" do visitante abre
 * o popup manualmente (aria-hidden + a mesma chave `themeExitPopup`, pra manter
 * showOnlyOnce e o descanso de 7 dias compartilhados com o desktop) em vez de
 * navegar; o close (X) e o toque fora fecham via listener proprio, porque o do
 * tema tambem nao esta ligado em touch.
 * ------------------------------------------------------------------------- */
(function () {
  var CHAVE_TEMA = 'themeExitPopup'; // lida pelo ExitPopup do Warehouse
  var CHAVE_DATA = 'lk_exit_popup_visto_em';
  var DIAS_DE_DESCANSO = 7;
  var SEGUNDOS_ANTES_DE_ARMAR = 20;
  var FAIXA_DE_SAIDA_PX = 120; // altura, a partir do topo, que conta como "indo embora" (desktop)

  var loja;
  try {
    loja = window.localStorage;
    loja.getItem(CHAVE_TEMA);
  } catch (e) {
    return; // navegador sem storage: deixa o comportamento nativo
  }

  // Ja viu o pop-up? So volta a valer depois do descanso. Compartilhado entre
  // desktop e mobile porque os dois leem/gravam a mesma CHAVE_TEMA/CHAVE_DATA.
  var visto = Number(loja.getItem(CHAVE_DATA) || 0);
  if (visto) {
    if (Date.now() - visto > DIAS_DE_DESCANSO * 86400000) {
      loja.removeItem(CHAVE_TEMA);
      loja.removeItem(CHAVE_DATA);
    } else {
      return; // dentro do descanso: o proprio tema ja segura
    }
  }

  var suportaHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var mobile = !suportaHover ||
    (window.matchMedia && window.matchMedia('(any-pointer: coarse), (max-width: 767px)').matches) ||
    (window.navigator && window.navigator.maxTouchPoints > 0);

  if (!mobile) {
    // Desktop: o tema liga o mouseleave normalmente, so calibramos a chave dele.
    function bloquear() {
      if (loja.getItem(CHAVE_TEMA) === null) loja.setItem(CHAVE_TEMA, 'aguardando');
    }
    function liberar() {
      if (loja.getItem(CHAVE_TEMA) === 'aguardando') loja.removeItem(CHAVE_TEMA);
    }

    bloquear();

    var armado = false;
    window.setTimeout(function () {
      armado = true;
    }, SEGUNDOS_ANTES_DE_ARMAR * 1000);

    document.addEventListener(
      'mousemove',
      function (evento) {
        if (!armado) return;
        if (evento.clientY <= FAIXA_DE_SAIDA_PX) liberar();
        else bloquear();
      },
      { passive: true }
    );

    // Quando o tema abre o pop-up ele grava "true" na chave. Registramos a data
    // para o descanso valer a partir dai.
    var painel = document.querySelector('[data-popup-type="exit"]');
    if (painel && window.MutationObserver) {
      new MutationObserver(function () {
        if (painel.getAttribute('aria-hidden') === 'false') {
          loja.setItem(CHAVE_DATA, String(Date.now()));
        }
      }).observe(painel, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    return;
  }

  // Mobile/touch: o listener nativo nunca e ligado (ver comentario acima).
  // Abrimos e fechamos o mesmo painel na mao, usando o botao de voltar como
  // proxy de exit-intent.
  var painelMobile = document.querySelector('[data-popup-type="exit"]');
  if (!painelMobile) return;

  var jaAbriuNestaPagina = false;
  var armadoMobile = false;
  var saidaPendente = false;
  if (loja.getItem(CHAVE_TEMA) === null) loja.setItem(CHAVE_TEMA, 'aguardando');

  function abrirPopupMobile() {
    if (document.visibilityState === 'hidden' || jaAbriuNestaPagina || loja.getItem(CHAVE_TEMA) === 'true') return;
    painelMobile.setAttribute('aria-hidden', 'false');
    loja.setItem(CHAVE_TEMA, 'true');
    loja.setItem(CHAVE_DATA, String(Date.now()));
    jaAbriuNestaPagina = true;
  }
  function fecharPopupMobile() {
    painelMobile.setAttribute('aria-hidden', 'true');
  }

  painelMobile.addEventListener('click', function (evento) {
    if (evento.target === painelMobile || evento.target.closest('[data-action="close-popup"]')) {
      fecharPopupMobile();
    }
  });

  window.setTimeout(function () {
    armadoMobile = true;
    if (loja.getItem(CHAVE_TEMA) !== 'true') {
      try {
        history.pushState({ lkExitTrap: true }, '', location.href);
      } catch (e) {
        // History indisponivel: fallback continua ativo.
      }
    }
  }, SEGUNDOS_ANTES_DE_ARMAR * 1000);

  window.addEventListener('popstate', function () {
    if (!armadoMobile) return;
    abrirPopupMobile();
  });
  document.addEventListener('visibilitychange', function () {
    if (!armadoMobile) return;
    if (document.visibilityState === 'hidden') saidaPendente = true;
    else if (saidaPendente) abrirPopupMobile();
  });
  window.setTimeout(function () {
    saidaPendente = true;
    abrirPopupMobile();
  }, SEGUNDOS_ANTES_DE_ARMAR * 2000);
})();

(function () {
  if (typeof document === 'undefined' || typeof document.querySelectorAll !== 'function') return;
  function traduzirSetas() {
    document.querySelectorAll('.flickity-button.next, .flickity-prev-next-button.next').forEach(function (el) {
      el.setAttribute('aria-label', 'Proximo');
    });
    document.querySelectorAll('.flickity-button.previous, .flickity-prev-next-button.previous').forEach(function (el) {
      el.setAttribute('aria-label', 'Anterior');
    });
  }
  traduzirSetas();
  if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('load', traduzirSetas);
  document.addEventListener('shopify:section:load', traduzirSetas);

  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || typeof form.querySelector !== 'function') return;
  var idInput = form.querySelector('input[name="id"]');
  var btn = form.querySelector('.product-form__add-button');
  if (!idInput || !btn) return;
  function syncBuy() {
    var vazio = !idInput.value;
    btn.disabled = vazio;
    if (btn.classList && btn.classList.toggle) btn.classList.toggle('button--disabled', vazio);
  }
  syncBuy();
  form.addEventListener('change', syncBuy);
  document.addEventListener('variant:change', syncBuy);
})();

/* ---------------------------------------------------------------------------
 * Tamanho obrigatório (25/09/2026). Clicar só na cor fazia a Shopify devolver a
 * primeira variante daquela cor e o tamanho P aparecia marcado: quem não trocava
 * comprava P. Guarda as opções que o cliente escolheu de fato; o que ele não
 * escolheu volta para "Selecione" e o botão de compra fica travado.
 * ------------------------------------------------------------------------- */
(function () {
  if (typeof document === 'undefined' || !document.addEventListener) return;
  var escolhidas = {};
  var SELETOR = 'input[data-option-position]';

  // form.id devolve o <input name="id"> do formulário; o id de verdade vem do atributo.
  function idDe(form) { return form.getAttribute('id'); }

  function doForm(el) {
    return el.getAttribute('form') || (el.form && idDe(el.form)) || '';
  }

  function faltando(form) {
    var picker = document.querySelector('variant-picker[form-id="' + idDe(form) + '"]');
    if (!picker) return [];
    var marcadas = escolhidas[idDe(form)] || {};
    var lista = [];
    picker.querySelectorAll('.product-form__option').forEach(function (op) {
      var radio = op.querySelector(SELETOR);
      if (radio && !marcadas[radio.getAttribute('data-option-position')]) lista.push(op);
    });
    return lista;
  }

  function aplicar(form) {
    if (!escolhidas[idDe(form)]) return;
    var falta = faltando(form);
    if (!falta.length) return;
    falta.forEach(function (op) {
      op.querySelectorAll(SELETOR).forEach(function (i) { i.checked = false; });
      op.querySelectorAll('.is-selected').forEach(function (a) { a.classList.remove('is-selected'); });
      var rotulo = op.querySelector('.product-form__selected-value');
      if (rotulo) rotulo.textContent = 'Selecione';
    });
    var id = form.querySelector('input[name="id"]');
    if (id) id.value = '';
    document.querySelectorAll('.product-form__add-button').forEach(function (btn) {
      if (btn.form !== form) return;
      btn.disabled = true;
      btn.classList.add('button--disabled');
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SELETOR)) return;
    var f = doForm(t);
    var form = document.forms[f];
    if (!form) return;
    (escolhidas[f] = escolhidas[f] || {})[t.getAttribute('data-option-position')] = true;
    if (!form.__tamanhoObrigatorio) {
      form.__tamanhoObrigatorio = true;
      form.addEventListener('product:rerender', function () { setTimeout(function () { aplicar(form); }, 0); });
      form.addEventListener('submit', function (ev) {
        var falta = faltando(form);
        if (!escolhidas[idDe(form)] || !falta.length) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        falta[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, true);
    }
  }, true);
})();
